import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { getUserStudyPlan } from 'actions/verdicts';
import { getUserSubjects } from 'actions/user';
import { updateStudentAdjustment } from 'actions/additional_adjustments';
import { Spinner } from 'UI';
import { Checkbox, Button } from '@haldor/ui';
import swal from 'sweetalert2';

var EditAdditionalAdjustmentSubjects = /*#__PURE__*/function (_Component) {
  _inherits(EditAdditionalAdjustmentSubjects, _Component);

  var _super = _createSuper(EditAdditionalAdjustmentSubjects);

  function EditAdditionalAdjustmentSubjects(props) {
    var _this;

    _classCallCheck(this, EditAdditionalAdjustmentSubjects);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.user != null) {
        _this.props.getUserSubjects(_this.props.adjustment.studentID).then(function () {
          if (_this.props.userSubjects.length > 0) {
            var subjects = _toConsumableArray(_this.props.userSubjects);

            subjects.forEach(function (subject) {
              var found = _this.props.adjustment.subjects.find(function (selectedSubject) {
                return selectedSubject.id == subject.id;
              });

              subject.selected = found != null;
              subject.active = true;
              return subject;
            });

            _this.props.adjustment.subjects.forEach(function (subject) {
              var found = subjects.find(function (selectedSubject) {
                return selectedSubject.id == subject.id;
              });

              if (found == null) {
                var newSubject = _objectSpread({}, subject);

                newSubject.selected = true;
                newSubject.active = false;
                subjects.push(newSubject);
              }
            });

            _this.setState({
              subjects: subjects,
              loading: false
            });
          } else {
            _this.setState({
              loading: false
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          var values, subjects, removedSubjects, response;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  values = JSON.parse(JSON.stringify(_this.props.adjustment));
                  subjects = values.subjects;
                  removedSubjects = [];

                  if (_this.state.subjects != null) {
                    _this.state.subjects.forEach(function (subject) {
                      if (subject.selected) {
                        // Add non selected subject
                        var found = _this.props.adjustment.subjects.find(function (selectedSubject) {
                          return selectedSubject.id == subject.id;
                        });

                        if (found == null) {
                          subjects.push(subject);
                        }
                      } else {
                        // Not selected remove from values if needed
                        var foundIndex = subjects.findIndex(function (selectedSubject) {
                          return selectedSubject.id == subject.id;
                        });

                        if (foundIndex > -1) {
                          removedSubjects.push(subjects[foundIndex].id);
                          subjects.splice(foundIndex, 1);
                        }
                      }
                    });
                  }

                  if (!(removedSubjects.length > 0)) {
                    _context.next = 11;
                    break;
                  }

                  _context.next = 7;
                  return swal.fire({
                    title: _this.props.translate('Are you sure?'),
                    text: _this.props.translate('If you delete a subject, the adjustment will no longer be used for those subjects.'),
                    showCancelButton: true,
                    focusConfirm: false,
                    cancelButtonText: _this.props.translate('No'),
                    confirmButtonText: _this.props.translate('Yes')
                  });

                case 7:
                  response = _context.sent;

                  if (!(response.value == null)) {
                    _context.next = 11;
                    break;
                  }

                  resolve(0);
                  return _context.abrupt("return", false);

                case 11:
                  values.subjects = subjects; // Clean up properties that doesnt need to be sent to the api

                  delete values.comments;
                  delete values.createdBy;
                  delete values.editedBy;
                  delete values.versions;
                  delete values.student;

                  _this.props.updateStudentAdjustment(values).then(function () {
                    resolve(1);

                    _this.props.onClose();
                  });

                case 18:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "selectAllSubjects", function (checked) {
      var subjects = _this.state.subjects;

      if (subjects != null) {
        subjects.forEach(function (subject) {
          subject.selected = checked;
          return subject;
        });
      }

      _this.setState({
        subjects: subjects
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubjectChange", function (_subject) {
      var subjects = _this.state.subjects;

      if (subjects != null) {
        subjects.forEach(function (subject) {
          if (subject.id == _subject.id) {
            if (_subject.selected == true) {
              subject.selected = false;
            } else {
              subject.selected = true;
            }

            return subject;
          }
        });
      }

      _this.setState({
        subjects: subjects
      });
    });

    _this.state = {
      subjects: null,
      loading: true,
      selectedSubjects: []
    };
    return _this;
  }

  _createClass(EditAdditionalAdjustmentSubjects, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          submitting = _this$props.submitting,
          handleSubmit = _this$props.handleSubmit,
          valid = _this$props.valid;
      var hasInactive = false;

      if (this.state.subjects != null) {
        hasInactive = this.state.subjects.find(function (subject) {
          return subject.active == false;
        }) != null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, !this.state.loading ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, this.props.translate('choose-subjects')), /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '.35rem'
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: this.selectAllSubjects,
        label: this.props.translate('select-all')
      })), this.state.subjects.map(function (subject) {
        if (subject.active == false) {
          return null;
        }

        var title = subject.title;

        if (subject.typeOfSchooling != null) {
          title += " (".concat(_this2.props.translate(subject.typeOfSchooling), ")");
        }

        return /*#__PURE__*/React.createElement("div", {
          style: {
            marginBottom: '.35rem'
          },
          key: subject.id
        }, /*#__PURE__*/React.createElement(Checkbox, {
          value: subject.selected,
          onChange: function onChange() {
            return _this2.onSubjectChange(subject);
          },
          label: title
        }));
      }), hasInactive ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, this.props.translate('Inactive subjects')), this.state.subjects.map(function (subject) {
        if (subject.active) {
          return null;
        }

        var title = subject.title;

        if (subject.typeOfSchooling != null) {
          title += " (".concat(_this2.props.translate(subject.typeOfSchooling), ")");
        }

        return /*#__PURE__*/React.createElement("div", {
          style: {
            marginBottom: '.35rem'
          },
          key: subject.id
        }, /*#__PURE__*/React.createElement(Checkbox, {
          value: subject.selected,
          onChange: function onChange() {
            return _this2.onSubjectChange(subject);
          },
          label: title
        }));
      })) : null) : /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row submit spacing"
      }, /*#__PURE__*/React.createElement("div", {
        className: "pull-right"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || !valid || this.state.category == ''
      }, this.props.translate('save'))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))));
    }
  }]);

  return EditAdditionalAdjustmentSubjects;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    studyPlans: state.Verdicts.userStudyPlans,
    additionalAdjustments: state.AdditionalAdjustments.adjustments,
    userSubjects: state.user.userSubjects,
    user: state.user.currentUser
  };
}

export default connect(mapStateToProps, {
  getUserStudyPlan: getUserStudyPlan,
  getUserSubjects: getUserSubjects,
  updateStudentAdjustment: updateStudentAdjustment
})(reduxForm({
  form: 'EditAdditionalAdjustmentSubjects',
  destroyOnUnmount: true
})(EditAdditionalAdjustmentSubjects));